<button
    [disabled]="true"
    style="position: relative;"
    class="loading-btn"
    >
    Chargement ...
</button>